import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamation = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 57,
	height: 68,
	viewBox: "0 0 57 68",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame 2087328523",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector 54",
			d: "M27.9551 6.46533C27.9551 17.4826 27.9551 50.5346 27.9551 39.5172C27.9551 32.7504 27.9551 25.9836 27.9551 19.2168",
			stroke: "var(--color-icon-base-500)",
			strokeWidth: 12.6311,
			strokeLinecap: "round"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector 55",
			d: "M28.25 61.0926C28.25 62.8281 28.25 59.7595 28.25 59.2563",
			stroke: "var(--color-icon-base-500)",
			strokeWidth: 12.6311,
			strokeLinecap: "round"
		})]
	})
});
const ForwardRef = forwardRef(SvgExclamation);
export default ForwardRef;
